import React from 'react'
import { Button, Skeleton, Stack } from '@mui/material'
import { generateRandomGuiID } from '../../../utils/commonUtils'
import sxs from './FullScreenActionDialogButtons.sxs'
import { useFullScreenActionDialogContext } from './context/FullScreenActionDialogContext'

const FullScreenActionDialogButtons: React.FC = () => {
    const {
        state: { isLoading, cancelProps, saveProps },
    } = useFullScreenActionDialogContext()

    const buttons = [cancelProps, saveProps].filter((x) => x !== undefined)

    if (isLoading) {
        return (
            <Stack flexDirection="row" justifyContent="flex-end" gap="0.875rem">
                <Skeleton variant="text" sx={sxs.fullScreenActionDialogHeaderButtonSkeleton} />
                <Skeleton variant="text" sx={sxs.fullScreenActionDialogHeaderButtonSkeleton} />
            </Stack>
        )
    }

    return (
        <Stack flexDirection="row" justifyContent="flex-end" gap="0.875rem">
            {buttons.map((button, idx) => (
                <Button
                    key={generateRandomGuiID()}
                    sx={[
                        sxs.fullScreenActionDialogHeaderButtonBase,
                        idx === buttons.length - 1
                            ? sxs.fullScreenActionDialogHeaderButtonDarkVariant
                            : sxs.fullScreenActionDialogHeaderButtonLightVariant,
                    ]}
                    startIcon={button.icon}
                    onClick={() => button?.action()}
                >
                    {button.label}
                </Button>
            ))}
        </Stack>
    )
}

export default FullScreenActionDialogButtons
